<div>
  <div class="font-semibold mb-3">
    <a
      role="link"
      aria-expanded="true"
      [routerLink]="categoryLink"
      class="no-underline text-current"
    >
      <span>{{ publicationCategory?.name }}</span>
    </a>
  </div>
  <div
    class="text-sm md:text-base lg:text-lg"
    [class.pointer-events-none]="articleBlockComponent?.isPremium"
  >
    <a
      role="link"
      [routerLink]="articleBlockComponent?.isPremium !== true ? link : undefined"
      class="no-underline text-current"
    >
      <h3 class="text-current">{{ title }}</h3>
    </a>
  </div>
</div>
<div class="flex justify-between gap-2">
  <div>
    <span aria-label="Data artykułu" class="text-sm font-semibold">{{
      publishedAt | date
    }}</span>
  </div>
  <div class="flex md:gap-6 gap-3 relative top-px">
    <tisa-article-block-metadata-button
      *ngIf="showShare"
      (click)="onShareClick()"
      role="button"
    >
      <tisa-icon icon="share"></tisa-icon>
    </tisa-article-block-metadata-button>
  </div>
</div>
